import { combineReducers } from '@reduxjs/toolkit';

import { getTariffPlansReducer } from './getTariffPlansSlice';
import { legalReportCreateReducer } from './legalReportCreateSlice';

export const financeReducer = combineReducers({
  legalReportCreate: legalReportCreateReducer,
  getTariffPlans: getTariffPlansReducer,
});
